import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { LeftBorder, TopBorder, RightBorder, BottomBorder } from '../../styles';

export default class CanvasBlockHighlighter extends PureComponent {
    render() {
        const { status } = this.props;
        if (!status) {
            return (
                null
            );
        }
        if (status === 'LOCKED') {
            return (
                <>
                    <LeftBorder red />
                    <TopBorder red />
                    <RightBorder red />
                    <BottomBorder red />
                </>
            );
        }
        if (status === 'SELECTED') {
            return (
                <>
                    <LeftBorder />
                    <TopBorder />
                    <RightBorder />
                    <BottomBorder />
                </>
            );
        }
        return null;
    }
}

CanvasBlockHighlighter.propTypes = {
    status: PropTypes.string,
};

CanvasBlockHighlighter.defaultProps = {
    status: null,
};
